<template>
  <div id="login-background" class="li-lo-background">
    <router-link to="/apply" class="logo">
      <div style="width: 200px; float: left;">
          <svg width="100%" height="100%" viewBox="0 0 441 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
              <g transform="matrix(1,0,0,1,-217.867,-443.326)">
                  <g transform="matrix(4.97792,0,0,5.01892,-1101.74,-1983.69)">
                      <text x="264.983px" y="492.946px" style="font-family:'Comfortaa-Bold', 'Comfortaa';font-weight:700;font-size:12px;fill:white;">W<tspan x="274.919px " y="492.946px ">a</tspan>termarks</text>
                      <text x="339.647px" y="492.946px" style="font-family:'Comfortaa-Bold', 'Comfortaa';font-weight:700;font-size:12px;fill:rgb(255,191,0);">.io</text>
                  </g>
              </g>
          </svg>
      </div>
    </router-link>  
    <router-link to="/apply" class="exit-button"><i class="material-icons" style="font-size: 50px;">close</i></router-link>
    <div class="uk-container">
      <div class="uk-position-center login-box">
        <div class="login-box-form">
          <form v-on:keyup.enter="login" class="uk-form-stacked uk-margin-small-bottom">
            <legend class="uk-legend uk-text-center">Welcome Back!</legend>
            <!-- EMAIL -->
            <div class="uk-margin">
              <label class="uk-form-label" for="form-horizontal-text-email">Email</label>
              <div class="uk-form-controls form-label">
                <input v-model="email" autocomplete="email" class="uk-input uk-form-expand" id="form-horizontal-text-email" type="text">
              </div>  
              <!-- PASSWORD -->   
              <label class="uk-form-label uk-margin-top" for="form-horizontal-text-password">Password</label>
              <div class="uk-form-controls">
                <input v-model="password" autocomplete="current-password" class="uk-input uk-form-expand" id="form-horizontal-text-password" type="password">
              </div> 
              <span class="uk-link uk-text uk-text-small uk-text-muted"><i>Forgot your password?</i></span>                                  
            </div> 
            <!-- LOGIN BUTTON -->
            <a @click="login" class="uk-button uk-button-danger uk-margin uk-width-1-1" style="font-size: 16px; border-radius: 2px;"><b>Login</b></a> 
            <div>
              <span>Don't have an account?&nbsp;</span> <router-link to="/register" class="uk-link">Sign up.</router-link>
            </div>        
          </form>
          <div class="hr-sect"><i>or</i></div>
          <!-- Google Sign In Button -->
          <button @click="googleSignInWithPopup" type="button" class="google-button uk-margin-small-top">
            <span class="google-button__icon">
              <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" id="Shape" fill="#EA4335"/><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" id="Shape" fill="#FBBC05"/><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" id="Shape" fill="#4285F4"/><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"/></svg>
            </span>
            <span class="google-button__text">Sign in with Google</span>
          </button>           
        </div>               
      </div>      
    </div>
    <!-- Floating Rotating Squares -->
    <ul class="bg-bubbles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>    
  </div>
</template>

<script>
  
  import firebase from 'firebase/app'

  export default {
    name: 'Homepage',
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login: function() {
        var me;
        me = this;

        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          function() {
            let user = firebase.auth().currentUser;
            // logged in
            UIkit.notification({message: '<i class="material-icons uk-inline wm-green2">how_to_reg</i> Welcome back ' + user.displayName + '.', pos: 'bottom-center'}) 
            // route to Apply
            me.$router.replace('/apply')
          },
          function(err) {
            // error
            UIkit.notification({message: '<i class="material-icons uk-inline wm-red">call_missed</i> Issue logging in: <br>' + err.message, pos: 'bottom-center'})
            // shake div            
          }
        )
      },
      googleSignInWithPopup: function() {
        var me;
        me = this;

        // Google Auth Provider
        var provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().signInWithPopup(provider).then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          
          // The signed-in user info.
          const user = result.user
          const userId = user.uid
          
          // Notify successful
          UIkit.notification({message: '<i class="material-icons uk-inline wm-green2">how_to_reg</i> Welcome back ' + user.displayName + '.', pos: 'bottom-center'})          
          
          // Remove sign up popup by forcibly switching to apply page
          me.$router.replace('/apply')

        }).catch(function(error) {
          console.log(error)
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
      },      
    }
  }
</script>

<style scoped>

.logo {
  position:absolute;
  left:60px;
  top:60px;
  z-index: 222;
}

.exit-button {
  position:absolute;
  right:50px;
  top:50px;
  z-index: 222;
}

.login-box {
  border: 1px solid gray;
  border-radius: 5px;
  width: 480px;
  background: white;
  z-index: 10 !important;
}

.login-box-form {
  padding: 40px;
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);  
  box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
  border-radius: 5px !important;
}

.uk-form-label  {
  font-size: 16px;
}

.li-lo-background {
  height: 100%;
  /* background image */
  background: url('../../../static/backgrounds/login/wave_blue_background.png') no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;  
  /* fill entire screen with no scroll */
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	height: 100vh;
	margin-top: -50vh;
	overflow: hidden;
}

.uk-input {
  border-radius: 3px !important;
}

  /* hr sect separator */
  .hr-sect {
    display: flex;
    flex-basis: 100%;
    align-items: center;
    color: rgba(0, 0, 0, 0.35);
    margin: 8px 0px;
  }
  .hr-sect::before,
  .hr-sect::after {
    content: "";
    flex-grow: 1;
    background: rgba(0, 0, 0, 0.35);
    height: 1px;
    font-size: 0px;
    line-height: 0px;
    margin: 0px 8px;
  }

  /* Google Sign In Button */
  .google-button {
    cursor: pointer;
    height: 40px;
    width: 100%;
    border-width: 0;
    background: white;
    color: #737373;
    border-radius: 5px;
    white-space: nowrap;
    box-shadow: 1px 1px 0px 1px rgba(0, 0, 0, 0.05);
    transition-property: background-color, box-shadow;
    transition-duration: 150ms;
    transition-timing-function: ease-in-out;
    padding: 0;
  }
  .google-button:focus, .google-button:hover {
    box-shadow: 1px 4px 5px 1px rgba(0, 0, 0, 0.1);
  }
  .google-button:active {
    background-color: #e5e5e5;
    box-shadow: none;
    transition-duration: 10ms;
  }

  .google-button__icon {
    display: inline-block;
    vertical-align: middle;
    margin: 8px 0 8px 8px;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
  }

  .google-button__icon--plus {
    width: 27px;
  }

  .google-button__text {
    display: inline-block;
    vertical-align: middle;
    padding: 0 24px;
    font-size: 14px;
    font-weight: bold;
    font-family: 'Roboto',arial,sans-serif;
  }

/* Square Floating */
.bg-bubbles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.bg-bubbles li {
  position: absolute;
  list-style: none;
  display: block;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.15);
  bottom: -160px;
  -webkit-animation: square 25s infinite;
  animation: square 25s infinite;
  transition-timing-function: linear;
}
.bg-bubbles li:nth-child(1) {
  left: 10%;
}
.bg-bubbles li:nth-child(2) {
  left: 20%;
  width: 80px;
  height: 80px;
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  -webkit-animation-duration: 12s;
          animation-duration: 12s;
}
.bg-bubbles li:nth-child(3) {
  left: 25%;
  -webkit-animation-delay: 4s;
          animation-delay: 4s;
}
.bg-bubbles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  -webkit-animation-duration: 22s;
          animation-duration: 22s;
  background-color: rgba(255, 255, 255, 0.25);
}
.bg-bubbles li:nth-child(5) {
  left: 70%;
}
.bg-bubbles li:nth-child(6) {
  left: 80%;
  width: 120px;
  height: 120px;
  -webkit-animation-delay: 3s;
          animation-delay: 3s;
  background-color: rgba(255, 255, 255, 0.2);
}
.bg-bubbles li:nth-child(7) {
  left: 32%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 7s;
          animation-delay: 7s;
}
.bg-bubbles li:nth-child(8) {
  left: 55%;
  width: 20px;
  height: 20px;
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
}
.bg-bubbles li:nth-child(9) {
  left: 25%;
  width: 10px;
  height: 10px;
  -webkit-animation-delay: 2s;
          animation-delay: 2s;
  -webkit-animation-duration: 40s;
          animation-duration: 40s;
  background-color: rgba(255, 255, 255, 0.3);
}
.bg-bubbles li:nth-child(10) {
  left: 90%;
  width: 160px;
  height: 160px;
  -webkit-animation-delay: 11s;
          animation-delay: 11s;
}
@-webkit-keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
            transform: translateY(-700px) rotate(600deg);
  }
}
@keyframes square {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-700px) rotate(600deg);
            transform: translateY(-700px) rotate(600deg);
  }
}

</style>